import { render, staticRenderFns } from "./FbIcon.vue?vue&type=template&id=635d472e&scoped=true"
import script from "./FbIcon.vue?vue&type=script&lang=js"
export * from "./FbIcon.vue?vue&type=script&lang=js"
import style0 from "./FbIcon.vue?vue&type=style&index=0&id=635d472e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d472e",
  null
  
)

export default component.exports